module.exports = __webpack_public_path__ + "78378432a9efc4848bc63c979ee6019d.png";